export function SetPesList(data) {
  return {
    type: 'PES_LIST',
    pesList: data || [],
  };
}
